import { c as _c } from "react/compiler-runtime";
import { Alert } from '@repo/ui/icons';
const SignatureDeadlineAlert = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-destructive-foreground/18 gap-xs p-xs flex items-center rounded-lg"><Alert className="text-destructive-foreground shrink-0" /><span className="text-2xs text-destructive-foreground">This signature is no longer valid. Close this dialog and retry the transaction.</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default SignatureDeadlineAlert;